import request from '../request'
// 自付额支付
const encrypt = (data) => {
  let url = '/api/wx/encrypt?'
  for (let key in data) {
    let val = data[key]
    if (val instanceof Array) {
      for (let i = 0; i < val.length; i++) {
        url += key + '=' + val[i] + '&'
      }
    } else {
      url += key + '=' + data[key] + '&'
    }
  }
  if (/&$/.test(url)) {
    url = url.substr(0, url.length - 1)
  }
  return request.get(url, data)
}
// 自付额度查询
const getIAmountCalimsInfo = (data) => {
  return request.post(`/api/wx/auth/getIAmountCalimsInfo`, data)
}
// 对象数组
export default {
  encrypt,
  getIAmountCalimsInfo
}
